import React from "react";
import Mald from "../src/portfolio3.jpg";

const Analytics = () => {
  return (
    <div className="bg-white" id="analytics">
      <div className="max-w-[1240px] w-full grid mx-auto p-4 mt-5 md:grid-cols-2 ">
        <div className="">
          <img className="w-[390px] mx-auto rounded" src={Mald} alt="" />
        </div>
        <div className="flex flex-col mx-auto ">
          <h2 className="uppercase text-green-500 p-1 text-xs mt-4 text-center">Data Analytics Dashboard</h2>
          <h1 className="text-3xl font-bold ">Manage Data Analytics Centrally</h1>
          <p className="p-1 text-[gray]">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio ipsa quam reiciendis vitae amet consectetur fugit nobis repellendus, dolorem neque pariatur, numquam eius voluptate suscipit asperiores non commodi fuga? Temporibus?</p>
          <button className="w-[200px] px-6 py-3 bg-black mx-auto rounded mt-4 text-green-600 hover:bg-green-600 hover:text-black">Get Started</button>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
